import React from 'react';
import PropTypes from 'prop-types';
import { useAttachSource } from '../../hooks/useAdminForms';
import DataSourceFields from './DataSourceFields';

// Point a dealership at its data source. The backend keeps one source per
// dealership, so picking a dealership that already has one re-points it in place
// rather than adding a second — the form pre-fills with what is connected today.
// Logic: hooks/useAdminForms (shared with the redesign).
function AttachSourceModal({ dealers, tenants, dealerId, onClose, onSaved }) {
    const {
        orgId, pickOrg, slug, setSlug, source, setSource, saving, error, existing, tenantFor, canSave, save,
    } = useAttachSource({ dealers, tenants, dealerId, onSaved, onClose });

    return (
        <div className="ac-modal-backdrop" onClick={onClose}>
            <div className="ac-modal" onClick={(e) => e.stopPropagation()}>
                <div className="ac-modal-head">
                    <h2>{existing ? 'Re-point data source' : 'Connect a data source'}</h2>
                    <button className="ac-modal-x" onClick={onClose} aria-label="Close">×</button>
                </div>

                <label className="ac-field">
                    <span>Dealership</span>
                    <select value={orgId} disabled={saving} onChange={(e) => pickOrg(e.target.value)}>
                        {dealers.map((d) => (
                            <option key={d.id} value={d.id}>
                                {d.name}{tenantFor(d.id) ? ' — already connected' : ''}
                            </option>
                        ))}
                    </select>
                </label>
                <label className="ac-field">
                    <span>Source key</span>
                    <div className="ac-slug-row">
                        <span className="ac-slug-prefix">tenant/</span>
                        <input type="text" value={slug} disabled={saving}
                            onChange={(e) => setSlug(e.target.value)} />
                    </div>
                </label>

                <DataSourceFields value={source} onChange={setSource} disabled={saving} autoFocus />

                {existing && (
                    <p className="ac-modal-hint">
                        This dealership already reads from a source. Saving a different endpoint re-points
                        it and puts it back to <strong>Waiting for data</strong> until it is verified again.
                    </p>
                )}
                {error && <div className="ac-error">{error}</div>}

                <div className="ac-modal-actions">
                    <button className="ac-btn-ghost" onClick={onClose} disabled={saving}>Cancel</button>
                    <button className="ac-btn-primary" onClick={save} disabled={saving || !canSave}>
                        {saving ? 'Connecting…' : existing ? 'Save source' : 'Connect source'}
                    </button>
                </div>
            </div>
        </div>
    );
}

AttachSourceModal.propTypes = {
    dealers: PropTypes.array.isRequired,
    tenants: PropTypes.array.isRequired,
    dealerId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onSaved: PropTypes.func.isRequired,
};

export default AttachSourceModal;
